import React from 'react'
import { SortableHeader, Table as BaseTable } from '@/components_deprecated'
import type { Filter } from '@/modules/vehicles'
import styled from 'styled-components'
import type { FilledOutFormNode, FormTemplateFieldNode } from '../../../formcreator'
import type { RelayEdges, RelayNode } from '../../../../types/graphql'
import type { UserNode } from '../../../users'

const Table = styled(BaseTable)`
  position: relative;

  thead {
    text-align: left;
  }

  tbody tr {
    &:hover {
      background: ${props => props.theme.colors.gray10};
    }
  }
`

interface TableProps {
  edges: RelayNode<
    Pick<FilledOutFormNode, 'id' | 'createdAt' | 'verifiedAt' | 'values'> & {
      filledBy: Pick<UserNode, 'id' | 'fullName'>
      verifiedBy: Pick<UserNode, 'id' | 'fullName'> | null
    }
  >[]
  filter: Filter
  onSort: (value: string) => void
  title?: string
  formFields: RelayEdges<FormTemplateFieldNode>
}

const MaterialTable: React.FC<TableProps> = ({
  edges,
  filter,
  onSort,
  title,
  formFields,
}) => {
  const fields = formFields?.edges?.map(e => e.node)
  const responses = edges?.map(e => e.node)

  const tableData = responses.map(response => {
    const row: Record<string, any> = {}
    fields.forEach((field: any) => {
      const valueObj = response.values?.find(
        (v: any) => v.formTemplateField.id === field.id
      )
      row[field.name] = valueObj?.value ?? '-'
    })
    return row
  })

  const allKeys = fields.map((f: { name: string }) => f.name)

  const formatCellValue = (value: any) => {
    if (value == null) return '-'
    if (typeof value === 'boolean') return value ? '✓' : '✗'
    return String(value)
  }

  return (
    <>
      {title && <h2>{title}</h2>}
      <Table>
        <thead>
          <tr>
            {allKeys?.map((key: string) => (
              <SortableHeader
                key={key}
                baseValue={key.replace(/\s/g, '__')}
                sortValue={filter?.orderBy}
                onSort={onSort}
              >
                {key}
              </SortableHeader>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData?.map((row, idx) => (
            <tr key={idx}>
              {allKeys?.map((key: string) => (
                <td key={key}>{formatCellValue(row[key])}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  )
}

export default MaterialTable
